import axios from 'axios'
import API_ENDPOINT from "../config"

export const getDashboardData  = async  (token) =>  {
    let fd = new FormData();
    fd.append("token",JSON.stringify(token));
    fd.append("identity","wmhandler");
    var res = await axios({method:"POST",url:`${API_ENDPOINT.apiUrl}adminPanel/getDashboardData`,data:fd})
    return res.data;
}